import { Controller } from "@hotwired/stimulus"

// Copies the value of a source input/field to the clipboard and briefly swaps
// the button label to confirm. Falls back to selecting the text when the
// Clipboard API is unavailable (e.g. non-secure contexts).
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { successText: { type: String, default: "Скопировано!" } }

  connect() {
    this.originalText = this.hasButtonTarget ? this.buttonTarget.textContent : null
  }

  async copy() {
    const text = this.sourceTarget.value

    try {
      await navigator.clipboard.writeText(text)
    } catch (_error) {
      this.sourceTarget.select()
      document.execCommand("copy")
    }

    this.flash()
  }

  flash() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.textContent = this.successTextValue
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      this.buttonTarget.textContent = this.originalText
    }, 1600)
  }
}
